import { setLocale } from "yup"

setLocale({
  mixed: {
    default: "validators.mixed.default",
    required: "validators.mixed.required",
    oneOf: "validators.mixed.oneOf",
    notOneOf: "validators.mixed.notOneOf"
  },
  string: {
    length: "validators.string.length",
    min: "validators.string.min",
    max: "validators.string.max",
    email: "validators.string.email",
    url: "validators.string.url",
    trim: "validators.string.trim",
    lowercase: "validators.string.lowercase",
    uppercase: "validators.string.uppercase"
  },
  number: {
    min: "validators.number.min",
    max: "validators.number.max",
    lessThan: "validators.number.lessThan",
    moreThan: "validators.number.moreThan",
    positive: "validators.number.positive",
    negative: "validators.number.negative",
    integer: "validators.number.integer"
  },
  date: {
    min: "validators.date.min",
    max: "validators.date.max"
  },
  array: {
    min: "validators.array.min",
    max: "validators.array.max"
  }
})
